(() => {
  'use strict';
  const mobile = matchMedia('(max-width:760px),(max-width:1023px) and (pointer:coarse)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  let entered = false;
  function enterFit() {
    if (location.hash !== '#ura-fit' || entered) return;
    const product = document.querySelector('[data-ura4-product][data-ura4-ready="true"]');
    const fit = product?.querySelector('[data-ura-fit-integrated][data-ura-fit-inline]');
    if (!fit) return;
    entered = true;
    const nav = document.querySelector('[data-ura-mobile-nav][data-mobile-nav-ready="true"]');
    if (mobile.matches && nav?.querySelector('[data-mnav-fit-product-host]')) {
      document.dispatchEvent(new CustomEvent('ura:mobile-panel-request', { detail: { panel: 'fit' } }));
    } else {
      if (fit.tagName === 'DETAILS') fit.open = true;
      fit.scrollIntoView({ block: 'center', behavior: reduced.matches ? 'auto' : 'smooth' });
      fit.focus({ preventScroll: true });
    }
  }
  if (document.readyState === 'complete') requestAnimationFrame(enterFit);
  else addEventListener('load', enterFit, { once: true });
  addEventListener('hashchange', () => { entered = false; requestAnimationFrame(enterFit); });
  addEventListener('pageshow', event => { if (event.persisted) { entered = false; requestAnimationFrame(enterFit); } });
})();
